import React, { Component } from 'react'

import { connect } from 'react-redux';
import {bindActionCreators} from "redux";


import _ from 'lodash';

import {SignIn,DreamTeamEntryCreation, CCActions, CCModalLayout} from '../../cc-imports'

const totalSalary = 10000;
const playersPerTeam =2;

class DreamTeamEntryCreationModal extends Component {

    static propTypes = {}

    static defaultProps = {}


    constructor(props) {
        super(props)
        this.initialState = {
            league : undefined,
            screen : 'dreamTeam'
        }

        this.state = this.initialState;

        this._closeModal=this._closeModal.bind(this);
        this._onModalHide=this._onModalHide.bind(this);
        this._changeScreen=this._changeScreen.bind(this);
        this._getLeague=this._getLeague.bind(this);
    }

    _closeModal() {
        this.props.actions.closeModal("DreamTeamEntryCreation");
    }

    _onModalHide(){
        this.setState(this.initialState, ()=>{
            this._closeModal();
        });
    }

    _getLeague(){
        var modal = _.find(this.props.modals.modals,(modal)=>{return modal.name=='DreamTeamEntryCreation'})
        if(modal){
            return modal.league
        }
        /*const league = this.props.leagues ? this.props.leagues.byId ? this.props.leagues.byId['5aedf887b3863354e980eccc'] : undefined : undefined;
        console.log(league)
        //this.setState({league:league})
        return league;*/
    }

    _changeScreen(screen){
        this.setState({screen})
    }

    render() {
        const {screen} = this.state;
        return (
            <CCModalLayout name={"DreamTeamEntryCreation"}>
                <div>
                        {
                            screen == 'dreamTeam' &&
                            <DreamTeamEntryCreation onAck={this._closeModal} league={this._getLeague()} openSignIn={()=>{this._changeScreen('signIn')}}/>
                        }
                        {
                            screen == 'signIn' &&
                            <SignIn onSignInSuccess={()=>{this._changeScreen('dreamTeam')}}/>
                        }
                </div>
            </CCModalLayout>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user : state.user,
        entries: state.entries,
        matches : state.matches,
        leagues : state.leagues
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(DreamTeamEntryCreationModal);


const ccStyle = {
    default:{
        playerItemSize : 'r',
        selectedPlayerItemSize : 's'
    },
    s : {
        playerItemSize : 's',
        selectedPlayerItemSize : 'xs'
    }
}


// WEBPACK FOOTER //
// ./src/app/modals/DreamTeamEntryCreationModal/DreamTeamEntryCreationModal.js